import React from 'react';
import { Hero } from '../components/Hero';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CallbackWidget } from '../components/CallbackWidget';
export function LandingPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-352">
      <Navigation data-id="element-353" />

      <main data-id="element-354">
        <Hero data-id="element-355" />
        <WhyChooseUs data-id="element-356" />
        <WhyUs data-id="element-357" />
        <Services data-id="element-358" />
        <FAQ data-id="element-359" />
        <Testimonials data-id="element-360" />
        <Consultation data-id="element-361" />
      </main>

      <Footer data-id="element-362" />
      <CookieBanner data-id="element-363" />
      <CallbackWidget data-id="element-364" />
    </div>;
}